import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../../../shared/pipes/shared-pipes.module';
import { SharedModule } from '../../../../shared/shared.module';
import { PlateService } from '../../../services/plate.service';
import { PlateSearchComponent } from './plate-search.component';
import { ToastModule } from 'primeng/toast';

@NgModule({
    declarations: [
        PlateSearchComponent
    ],
    providers: [
        PlateService
    ],
    exports: [
        PlateSearchComponent
    ],
    imports: [
        SharedModule,
        SharedPipesModule,
        TableModule,
        ToastModule
    ]
})
export class PlateSearchModule {
}
